import { LoadablePaint } from '@confluence/loadable';

export const SmartCreatePageEditorLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-smartCreatePageEditorWrapper" */ './SmartCreatePageEditorDataWrapper'
			)
		).SmartCreatePageEditorDataWrapper,
});
